var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "github",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.231,
    height: 43.14,
    viewBox: "0 0 44.231 43.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M22.116,0a22.118,22.118,0,0,0-6.992,43.1c1.105.2,1.511-.48,1.511-1.064,0-.527-.021-2.27-.03-4.118-6.153,1.338-7.451-2.609-7.451-2.609A5.855,5.855,0,0,0,6.7,32.075C4.692,30.7,6.85,30.73,6.85,30.73a4.649,4.649,0,0,1,3.39,2.279c1.972,3.381,5.174,2.4,6.436,1.839a4.71,4.71,0,0,1,1.4-2.957C13.168,31.331,8,29.435,8,20.961a8.559,8.559,0,0,1,2.279-5.936A7.947,7.947,0,0,1,10.5,9.172s1.857-.594,6.083,2.267a20.98,20.98,0,0,1,11.076,0c4.221-2.861,6.076-2.267,6.076-2.267a7.937,7.937,0,0,1,.217,5.853,8.542,8.542,0,0,1,2.276,5.936c0,8.494-5.174,10.365-10.1,10.912a5.287,5.287,0,0,1,1.5,4.1c0,2.959-.026,5.341-.026,6.069,0,.589.4,1.278,1.519,1.061a22.119,22.119,0,0,0-7-43.1",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M44.932,179.847c-.049.11-.222.143-.379.067s-.251-.222-.2-.332.221-.145.381-.069.252.223.2.334m1.088.971c-.105.1-.312.052-.452-.1a.338.338,0,0,1-.065-.46c.109-.1.309-.052.454.1s.173.361.062.46m.747,1.242c-.136.094-.357.006-.494-.191s-.135-.432,0-.527.356-.01.494.186.135.436,0,.532m1.262,1.438c-.121.134-.379.1-.568-.085a.425.425,0,0,1-.126-.565c.123-.134.382-.1.573.085s.251.433.121.565m1.631.486c-.053.173-.3.252-.552.178s-.414-.279-.363-.454.3-.256.554-.178.414.277.362.453m1.856.206c.006.182-.206.334-.469.337s-.478-.142-.481-.321.208-.334.472-.338.478.141.478.323m1.824-.07c.032.178-.151.361-.412.409s-.494-.063-.527-.239.154-.365.411-.412.5.062.529.242",
    transform: "translate(-36.649 -148.342)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.0aab637846cca5387bb673b54358f0a4.svg";
export { ForwardRef as ReactComponent };